mod.modules.define("SymbolsTable", function(fn) {

	var lastXhr = null;
	var lastSearchTerm = null;
    var displayOptionNum = 50;  //default number for display option

	fn.prototype.init = function() {
		this.el.find("#inputCompany").defaultValue();
	};

	fn.prototype.observables = {
		"symbol - changed": function(context) {
			this.reloadQueue({
				Symbol: context.symbol,
				ListId: context.listId,
				PageIndex: 0 // reset the index
			});
		}
	};

	fn.prototype.callServer = function(overridingData) {
		var self = this;
		var $input = this.el.find("#inputCompany");

		var data = $.extend(
			{
				SearchTerm: $input.val(),
				PageIndex: this.el.find("select.pager-select-page").val()
			},
			overridingData
		);

		// Kill any running queries
		if (lastXhr) {
			lastXhr.abort();
		}

		// Fire off the request to the server for the new markup
		lastXhr = this.ajax(
			data,
			function(response) {
				// Replace the table
				if (response.table) {
					var $newHtml = $(response.table);
					var $newTable = $newHtml.find("table.data");
					self.el.find("table.data").replaceWith($newTable);
				}

				// Replace the paging
				if (response.pagination) {
					var $buttons = $(response.pagination).html();
					self.el.find("span.pager-wrap-buttons").html($buttons);
				}
                if (response.displayOptions) {
                    $(".num-results-per-page").replaceWith(response.displayOptions);
                }
			}
		);

		// Put the focus back on the input, or else the user might be sent "back" by hitting Backspace
		$input.triggerHandler("focus");
	};

	fn.prototype.events = {
		"#inputCompany": {
			"keyup": function(e, $el) {
				var isDeleteKey = e.keyCode === 8;
				var isDeletingNothing = !lastSearchTerm && isDeleteKey;
				var term = $el.val();

				if (!isDeletingNothing && term != lastSearchTerm) {
					var data = {};

					// Reset the page if we don't have a search term
					if (!term) {
						data.PageIndex = 0;
					}

					this.callServer(data);
					lastSearchTerm = term;
				}
			}
		},
		".pager-wrap [data-pageindex]:not([disabled=disabled])": {
		    "click": function (e, $el) {
				this.callServer({
					SearchTerm: null,
					PageIndex: $el.attr("data-pageindex"),
					PageSize: displayOptionNum
				});
			}
		},
		".pager-wrap select.pager-select-page": {
		    "change": function (e, $el) {
				this.callServer({
					SearchTerm: null,
					PageIndex: $el.val(),
					PageSize: displayOptionNum
				});
			}
		},
		".num-results-selector": {
	      "change": function(e, $el) {
	          displayOptionNum = $el.val();
	      
	          this.callServer({
	              SearchTerm: null,
	              PageSize: displayOptionNum
	           });
	      }  
	    },
		"a[data-sortfield]": {
			"click": function(e, $el) {
				var oldSortDir = $el.attr("data-sortdir");
				var newSortDir = (oldSortDir == "asc") ? "Descending" : "Ascending";

				this.reload({
					SortField: $el.attr("data-sortfield"),
					SortDirection: newSortDir
				});
			}
		}
	};

});